import IncidentListToolbar from '@/views/incident/toolbars/IncidentListToolbar';
import IncidentViewToolbar from '@/views/incident/toolbars/IncidentViewToolbar';
import IncidentView from '@/views/incident/IncidentView';
import IncidentList from '@/views/incident/IncidentList';
import DefaultLayout from '@/layout/DefaultLayout';
import { STATES } from '@/constants';

export const incidentAdditionalQuestionRoutes = [
  {
    path: '/incident-additional-question',
    name: 'incident-additional-question',
    components: {
      default: IncidentList,
      toolbar: IncidentListToolbar
    },
    meta: {
      type: STATES.ADDITIONAL_QUESTION,
      sortBy: 'UPDATED_AT',
      title: 'Дозапрос',
      layout: DefaultLayout
    }
  },
  {
    path: '/incident-additional-question/:id',
    name: 'incident-additional-question-view',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    component: IncidentView,
    meta: {
      layout: DefaultLayout,
      type: STATES.ADDITIONAL_QUESTION
    }
  },
  {
    path: '/incident-additional-question/:id/more/:moreId?',
    name: 'incident-additional-question-view-more',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    component: IncidentView,
    meta: {
      layout: DefaultLayout,
      type: STATES.ADDITIONAL_QUESTION
    }
  }
];
